import { memo } from "react";
import PropTypes from "prop-types";

function Title({ title, subTitle }) {
  return (
    <div className="text-center relative top-[6px]">
      <h2 className="text-title font-semibold text-5xl mb-[15px] table:text-4xl mobile:text-3xl">
        {title}
      </h2>
      <h3 className="text-subTitle font-normal text-xl">{subTitle}</h3>
    </div>
  );
}

export default memo(Title);

Title.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
};
